import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';

const showNotification = (message, theme) => {
  Toastify({
    text: message,
    duration: 2000,
    gravity: 'top',
    position: 'right',
    style: {
      background: theme === 'dark' ? 'black' : 'white',
      color: theme === 'dark' ? 'white' : 'black',
    },
  }).showToast();
};

export { showNotification };
